import React from 'react';
import { createImageUrl } from '../../services/data';
import { addDefaultSource, handleImgLoad } from '../../services/errorHandlers';
import List from '@mui/material/List';

interface ImageItem {
    id?: string | number;
    fileId: string | null;
}

interface ImagesCarouselProps {
    images: ImageItem[] | undefined;
}

const ImagesCarousel: React.FC<ImagesCarouselProps> = ({images}) => {
    return (
        <div className='images-carousel' style={{width: 'fit-content', margin: '0 auto'}}>
            <List sx={{
                listStyle: 'none',
                display: 'flex',
                gap: '2vw',
                height: '5rem',
                padding: 0
            }}>
                {
                    images?.map(image => {
                        return (<li key={image.id} style={{width: '5rem', borderRadius: '0.7rem'}}>
                            <img src={createImageUrl(image.fileId)} alt={`${image.id}`}  onError={addDefaultSource} onLoad={handleImgLoad}/>
                        </li>)
                    })
                }
            </List>
        </div>
    );
};

export default ImagesCarousel;
